import { Component, OnInit } from '@angular/core';
import { PHBHPLayoutPackageService } from '../ph-bhp-layout-package.service'

@Component({
  selector: 'lib-ph-loader',
  templateUrl: './ph-loader.component.html',
  styleUrls: ['./ph-loader.component.css']
})
export class PhLoaderComponent implements OnInit {

  constructor(public service : PHBHPLayoutPackageService) { }

  ngOnInit() {
  }

}
